import useMedia from '~hooks/useMedia';

import { Content } from '../../style';
import { S } from './style';

function CompanyMenuSkeleton() {
  const { isMobile } = useMedia();

  return (
    <S.Wrapper>
      <div />
      <div />
      <div />
      <div />
    </S.Wrapper>
  );
}

export default CompanyMenuSkeleton;
